export function hasWindow(): boolean {
    return typeof window !== 'undefined';
}

export function isIE(): boolean {
    return (
        hasWindow() &&
        (window.navigator.userAgent.includes('MSIE') ||
            window.navigator.appVersion.includes('Trident/'))
    );
}
